export const JIRA_LABELS = {
	evincedScannerIssue: 'evinced-scanner-issue'
};
